<template>
  <div class="iv-bag-panel">
    <label class="bag-label">Total Number of IV Bags Infusing</label>
    <vue-slider 
      class="slider ui-theme-3"
      :min="1"
      :max="maxBagsAvailable"
      :dot-size="35"
      :height="6"
      :contained="true"                
      :dot-style="{backgroundColor: '#0C70B0'}"
      :value="[iv.bagCount]"
      :disabled="readonly"
      @change="updateBagCount"
    />
  </div>
</template>

<script>
import { merge } from 'lodash';
import VueSlider from 'vue-slider-component';

export default {
  name: 'iv-bag-panel',
  components: {
    VueSlider,
  },
  props: {
    iv: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maxBagsAvailable() {
      return this.$featureAvailabilityService.getLimit('MAX_BAGS_AVAILABLE');
    },
  },
  methods: {
    updateBagCount(bagCount) {
      const newIv = merge({}, this.iv, { bagCount });
      this.emitUpdate(newIv);
    },
    emitUpdate(iv) {
      this.$emit('updateIv', iv);
    }
  }
}
</script>

<style scoped>
.iv-bag-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bag-label {
  margin-right: 1rem;
}

.slider {
  flex: 1;
  min-width: 400px;
}
</style>